import { formatePrice as FP } from '@/utils/formatePrice'
/**
 * @param {number} price
 */
export function formatePrice (price) {
  let orgPrice = Number(price) || 0
  return orgPrice.toFixed(2)
}

export function formatePrice4 (val) {
  if (val) {
    if (typeof val !== 'number') {
      val = val - 0
    }
    return FP(val.toFixed(4))
  }
  if (val === null) {
    return '-'
  }
  return '0.0000'
}